import type { ConsumptionSummaryResponse } from '@shared/api/rtkQuery'

export const FIELD_DICT = { orderCount: 'Order Count', revenue: 'Revenue' }

export const CONSUMPTION_SUMMARY_KEYS: Array<keyof ConsumptionSummaryResponse> =
  ['summary30D', 'summary60D', 'summary90D', 'summary180D']
